module.exports = __webpack_public_path__ + "static/media/996701.0024b7e9.png";